/*
        ----- Important Notice -----
        This code is the intellectual property of Laxab Digital Solutions Pvt Ltd (Regd company in India,
        hereafter referred as 'company'). If you are not an employee this company, you are not authorized 
        to copy, save, or transmit this code in any form or medium without prior written permission from 
        the company.

        For more information, please visit company's website: www.laxab.com/intellectualproperty

        ----->> app.js  >  root.js  >  body.js

        Version 1.0 : 09 Jun 2023, Created      ***Current version***
*/

// Components
import BizBody from "../typeB/bizBody"
import DialogBox from "../../businessComponents/mui/dialogbox"
import Pending from "../../businessComponents/standards/Pending"

const Body = () => {

    return <div >
        <DialogBox/>
        <Pending/>
        <BizBody/>
    </div>

}

export default Body